/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Inject } from '@angular/core';
import {
  ADD_FAMILY_INFORMATION_FACADE_TOKEN,
  IAddFamilyInformationFacade,
} from '../../../../data-access/src/lib/domain/facades-models/add-family-information-facade-interface';
import { IFamilyInformationItem } from '../../../../../toolbelt/feature/src/lib/components/add-family-information/add-family-information-types';

export class AddFamilyProjectDataInfo {
  constructor(
    @Inject(ADD_FAMILY_INFORMATION_FACADE_TOKEN) private addFamilyInformationFacade: IAddFamilyInformationFacade
  ) {}

  public getModifiedProjectParameters(item: IFamilyInformationItem, isProjectDataBtnDisabled: boolean): void {
    if (Array.isArray(item.parameters)) {
      item.parameters = { parameters: [] };
    }
    const editFamilyItem = this.addFamilyInformationFacade.getFamilyInformationItem() as IFamilyInformationItem;
    if (isProjectDataBtnDisabled) {
      item.pushParameters = '';
      item.parameters = undefined;
      return;
    }
    const result = this.addFamilyInformationFacade.getUpdatedProjectParameters() as any;
    if (result !== null && result !== undefined) {
    item.parameters = editFamilyItem?.parameters;
    item.pushParameters = !isProjectDataBtnDisabled ? editFamilyItem?.pushParameters : '';
    }
  }
}